export default __webpack_public_path__ + "static/social-illustration-light-2cacfa4f8c1819931f8edf59a2ed1874.svg";